import type { Blank } from 'store/types/common';

import { InfoCard } from '../../ui-kit/info-card';
import { GOAL, GOAL_TITLE, PLAN, PROGRAM } from '../constants';

import { ClientGoalHistory } from './client-blank-goal-history';
import { getLatestByDateAndId } from 'shared/utils/get-latest-by-date-and-id';

import styles from './styles.module.scss';

interface ClientGoalProps {
	data: Blank;
}

export const ClientGoal = ({ data }: ClientGoalProps) => {
	// Находим patientEstimate с самой поздней датой (при равных датах - с большим ID)
	const lastEstimate = getLatestByDateAndId(data.patientEstimates);

	return (
		<div className={styles.goal}>
			<h3 className={styles.goal__title}>{GOAL_TITLE}</h3>

			<InfoCard
				className={styles.goal__card}
				values={[
					[
						GOAL,
						data.patientEstimates.length > 0 ? lastEstimate?.goal : '-',
						data.patientEstimates.length > 1 ? (
							<ClientGoalHistory history={data.patientEstimates} />
						) : undefined,
					],
					[PROGRAM, data.program],
					[PLAN, data.patientEstimates.length > 0 ? lastEstimate?.goalPlan : '-'],
				]}
			/>
		</div>
	);
};
